import { render, staticRenderFns } from "./PaymentPurposeTable.vue?vue&type=template&id=0909a0e8"
import script from "./PaymentPurposeTable.vue?vue&type=script&lang=js"
export * from "./PaymentPurposeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports